import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles, MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { withRoomContext } from '../../../RoomContext';
import { Button } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import * as requestActions from '../../../actions/requestActions';
import * as roomActions from '../../../actions/roomActions';
import { useLocation, useHistory } from 'react-router-dom';

// confirmModal
import ConfirmDialog from '../Common/ConfirmDialog';

// Firebase
import { functions } from '../../../lib/firebase';

const styles = () =>
	({
		root :
		{
			width           : '92%',
			height          : '90%',
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			overflow        : 'hidden',
			borderRadius    : '20px',
			backgroundColor : '#e5e5e2',
			padding         : '2%',
			maxWidth        : 1600,
			alignItems      : 'center',
			justifyContent  : 'center',
			zIndex          : 1
		},
		rootM :
		{
			width           : '98%',
			height          : '100%',
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			overflow        : 'auto',
			borderRadius    : '20px',
			backgroundColor : '#e5e5e2',
			padding         : '2%',
			maxWidth        : 1600,
			alignItems      : 'center',
			justifyContent  : 'flex-start',
			zIndex          : 1
		},
		title :
		{
			width          : '100%',
			display        : 'flex',
			flexDirection  : 'column',
			justifyContent : 'center',
			alignItems     : 'center',
			color          : '#989797',
			fontSize       : '1rem',
			marginBottom   : '7%'
		},
		icon :
		{
			width        : '3rem',
			marginBottom : '3%'
		},
		dialog :
		{
			backgroundColor : '#fff',
			padding         : '3% 5%',
			borderRadius    : '0.5rem',
			boxShadow       : '2px 2px 4px #989797',
			color           : '#989797',
			textAlign       : 'center',
			marginBottom    : '5%'
		},
		dialogM :
		{
			width           : '100%',
			backgroundColor : '#fff',
			padding         : '2% 2%',
			borderRadius    : '0.5rem',
			boxShadow       : '2px 2px 4px #989797',
			color           : '#989797',
			textAlign       : 'center',
			marginBottom    : '5%'
		},
		message :
		{
			marginBottom : '5%'
		},
		input :
		{
			width          : '100%',
			display        : 'flex',
			justifyContent : 'center',
			alignItems     : 'center'
		},
		inputField :
		{
			width                       : '100%',
			'& .MuiOutlinedInput-input' :
			{
				borderRadius : '0.5rem'
			}
		},
		inputLabel :
		{
			fontSize     : '0.8rem',
			minWidth     : '3.5rem',
			color        : '#999898',
			border       : '1px solid #999898',
			borderRadius : '0.5rem',
			padding      : '1% 1%',
			marginLeft   : '2%'
		},
		control :
		{
			width          : '10rem',
			display        : 'flex',
			justifyContent : 'center',
			alignItems     : 'center',
			marginBottom   : '5%'
		},
		closeBtn :
		{
			width           : '4rem',
			height          : '4rem',
			borderRadius    : '4rem',
			boxShadow       : '1px 1px 4px #777',
			backgroundColor : '#989797',
			color           : 'white',
			'&:hover'       :
			{
				backgroundColor : '#f50057'
			}
		},
		retryBtn :
		{
			display         : 'none',
			width           : '4rem',
			height          : '4rem',
			borderRadius    : '4rem',
			boxShadow       : '1px 1px 4px #777',
			backgroundColor : '#fff',
			color           : '#929191',
			'&:hover'       :
			{
				backgroundColor : '#f50057'
			}
		},
		warning :
		{
			width          : '100%',
			display        : 'flex',
			flexDirection  : 'column',
			justifyContent : 'center',
			alignItems     : 'center'
		},
		warningIcon :
		{
			width        : '2rem',
			marginBottom : '1%'
		},
		warningMessage :
		{
			textAlign : 'center',
			color     : '#929191'
		},
		sendingIndicator :
		{
			animation : '$blinkEffect 1.25s ease infinite'
		},
		'@keyframes blinkEffect' : {
			'0%' : {
				opacity : 0
			},
			'100%' : {
				opacity : 1
			}
		},
		sendingMessage :
		{
			width    : '250px',
			fontSize : '1.05rem'
		}
	});

const theme = createTheme({
	overrides : {
		PrivateNotchedOutline : {
			root : {
				borderRadius : '0.5rem',
				border       : 'none',
				boxShadow    : '2px 2px 4px inset #999898'
			}
		},
		MuiOutlinedInput : {
			input : {
				padding         : '0.3rem 0.5rem',
				border          : 'none',
				borderRadius    : '0.5rem',
				backgroundColor : '#999898',
				boxShadow       : '2px 2px 4px inset #999898',
				color           : 'white',
				width           : '100%',
				textAlign       : 'center'
			},
			notchedOutline : {
				border : 'none'
			}
		}
	}
});

const GuestHungUpView = ({
	room,
	roomClient,
	resetRoom,
	mediaPerms,
	classes,
	chat,
	isMobile,
	notifyToGuest
}) =>
{
	const [ userEmail, setUserEmail ] = useState('');
	const [ isSendingEmail, setIsSendingEmail ] = useState(false);
	const [ confirmDialogState, setConfirmDialogState ]= useState({
		show    : false,
		title   : '',
		message : ''
	});

	const location = useLocation();
	const history = useHistory();

	const closeCionfirmDialog = () =>
	{
		setConfirmDialogState(() =>
		{
			return {
				show    : false,
				title   : '',
				message : ''
			};
		});
	};

	const parts = window.location.hostname.split('.');
	const subdomain = parts.shift();

	const sendChatLogByEmailAPI = functions.httpsCallable('sendChatLogByEmail');

	const handleChangeUserEmail = (e) =>
	{
		setUserEmail(e.target.value);
	};

	const sendEmail = async () =>
	{

		if (!chat)
		{
			setConfirmDialogState({
				show    : true,
				title   : 'データエラー',
				message : 'チャットのデータが見つかりませんでした。'
			});
		}
		else
		{
			let msgExist = false;

			chat.forEach((msg) =>
			{
				if (msg.type === 'message')
				{
					msgExist = true;

					return;
				}
			});

			const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

			if (msgExist === false)
			{
				setConfirmDialogState({
					show    : true,
					title   : 'データエラー',
					message : 'チャットでの交信はございませんでした'
				});
			}
			else if (!emailPattern.test(userEmail))
			{
				setConfirmDialogState({
					show    : true,
					title   : 'メールアドレスエラー',
					message : 'メールアドレスが正しくありません'
				});
			}
			else
			{
				setIsSendingEmail(true);

				const result = await sendChatLogByEmailAPI({
					chat      : chat,
					userEmail : userEmail
				});

				if (result.data === 'success')
				{
					notifyToGuest({
						text : 'チャットの内容をご指定のメールアドレスに送付しました'
					});
					setUserEmail('');
				}
				else
				{
					setConfirmDialogState({
						show    : true,
						title   : '送信エラー',
						message : '送信中にエラーが発生しました'
					});
				}

				setIsSendingEmail(false);

			}
		}
	};

	const close = () =>
	{
		resetRoom();
		if (location.state?.directMode)
		{
			history.replace({
				pathname : '/lobby',
				state    : { directMode: false }
			});
		}
		else
		{
			window.location.reload();
		}
	};

	const reconnect = useCallback(() =>
	{
		roomClient.join({
			roomId    : room.name,
			joinVideo : mediaPerms.video,
			joinAudio : mediaPerms.audio,
			subdomain : subdomain
		});
	}, [ room.name, roomClient, mediaPerms.video, mediaPerms.audio, subdomain ]);

	return (
		<MuiThemeProvider theme={theme}>
			<ConfirmDialog
				show={confirmDialogState.show}
				title={confirmDialogState.title}
				message={confirmDialogState.message}
				accept={() => {}}
				cancel={closeCionfirmDialog}
				closeButtonOnly
			/>

			<div className={isMobile ? classes.rootM : classes.root}>
				<div className={classes.title}>
					<img src='images/icon_guest_hungup.svg' alt='logo' className={classes.icon}/>
					<div className={classes.title}>通話が終了いたしました。</div>
				</div>
				<div className={isMobile ? classes.dialogM : classes.dialog}>
					<div className={classes.message}>
						チャット内容を送る場合は
						<br/>
						メールアドレスを入力して送信ボタンを押してください
					</div>
					<div className={classes.input}>

						{
							!isSendingEmail ?
								<>
									<TextField
										id='email'
										value={userEmail}
										variant='outlined'
										name='email'
										type='email'
										placeholder='0000_0000@000.com'
										classes={{
											root : classes.inputField
										}}
										onChange={(event) => handleChangeUserEmail(event)}
									/>

									<Button
										className={classes.inputLabel}
										onClick={sendEmail}
										disabled={isSendingEmail}
									>
										送信
									</Button>
								</>
								:
								<Typography variant='caption' className={classes.sendingMessage}>
									送信中<span className={classes.sendingIndicator} >・・・</span>
								</Typography>
						}

					</div>
				</div>
				<div className={classes.control}>
					<Button className={classes.closeBtn} onClick={close}>閉じる</Button>
				</div>
				<div className={classes.warning}>
					<img src='images/icon_guest_warning.svg' alt='warning' className={classes.warningIcon}/>
					<div className={classes.warningMessage}>
						通信環境などにより、通話が途切れてしまった場合
						閉じるボタンを押し、再度おかけ直しください。
					</div>
				</div>
			</div>
		</MuiThemeProvider>
	);
};

GuestHungUpView.propTypes =
{
	room          : PropTypes.object.isRequired,
	roomClient    : PropTypes.object.isRequired,
	classes       : PropTypes.object.isRequired,
	mediaPerms    : PropTypes.object.isRequired,
	notifyToGuest : PropTypes.func.isRequired,
	resetRoom     : PropTypes.func.isRequired,
	chat          : PropTypes.array,
	isMobile      : PropTypes.bool.isRequired,
	orientation   : PropTypes.string
};

const mapStateToProps = (state) =>
{
	return {
		room        : state.room,
		mediaPerms  : state.settings.mediaPerms,
		chat        : state.chat,
		isMobile    : state.me.browser.platform === 'mobile' || state.me.useMobileView,
		orientation : state.room.orientation ?
			state.room.orientation : state.me.useMobileOrientation
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		notifyToGuest : (message) =>
		{
			dispatch(requestActions.notify(message));
		},
		resetRoom : () =>
		{
			dispatch(roomActions.resetRoom());
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room &&
				prev.chat === next.chat &&
				prev.room.orientation === next.room.orientation
			);
		}
	}
)(withStyles(styles)(GuestHungUpView)));